import styles from './header-phone.module.scss';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { device } from '../../../services/device-detector.service';
import { displayFlyingButton } from '../../../redux/display-slice';
import { analyticsService } from '../../../analytics.service';
import { AnalyticsEvent } from '../../../enums/analytics-event.enum';
import { SceneToken } from '../../../enums/scene-token.enum';
import { QuizHistoryService, browserHistoryService } from '../../../services/history.service';
import { scrollToTop } from '../../../utils';
import { BrowserHistoryCommand } from '../../../enums/browser-history-command.enum';

interface PhoneProps {
	phone: string
  mode?: "PC" | "mobile",
  historyService: QuizHistoryService
}

export default function HeaderPhone({ phone, historyService, mode = "PC" }:PhoneProps) {
	const dispatch = useDispatch();

	const clickButtonHandler = () => {
    let nextScene = { token: SceneToken.SIGN_UP }

    historyService.push(nextScene, false).then(() => {
      scrollToTop();
      browserHistoryService.perform(BrowserHistoryCommand.PUSH, nextScene);
    })
    
    analyticsService.send(AnalyticsEvent.CLICK_HEADER_PHONE);
  }

	return (
    device.isMobile() ? 
    <a className={styles.phone} 
      href={'tel:' + phone.replace(/[()-\s]/g, '')}
      target="_blank"
      onClick={() => analyticsService.send(AnalyticsEvent.CLICK_HEADER_PHONE)}
			rel="noopener noreferrer"
    >
    </a> :
		<button className={classNames(styles.phone)} 
			onClick={clickButtonHandler}
      onMouseEnter={() => dispatch(displayFlyingButton(false))}
      onMouseLeave={() => dispatch(displayFlyingButton(true))}
    >
      {phone}
		</button>
	)
}